import { render } from "./MyDialog.vue?vue&type=template&id=1f874022&scoped=true"
import script from "./MyDialog.vue?vue&type=script&lang=js"
export * from "./MyDialog.vue?vue&type=script&lang=js"

import "./MyDialog.vue?vue&type=style&index=0&id=1f874022&scoped=true&lang=css"

import exportComponent from "/home/walnit/Documents/AppVenture/nush-bookings-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f874022"]])

export default __exports__